<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import { clone } from 'lodash'
  import { changeBool } from '@/helper'
  import api from '@/api'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'
  import FileUploader from '@/components/ui/FileUploader'
  import LinkPreview from '@/components/ui/LinkPreview'

  export default {
    name: 'CooperationRequestOverlay',
    components: {
      FileUploader,
      LinkPreview,
      FallbackAvatar,
    },
    props: {
      isOpen: Boolean,
    },
    data() {
      return {
        files: [],
        fileUploaderConfig: {
          // Should add file config properties here which different from FileUploader's baseConfig settings
        },
        isPendingPreview: false,
        isPendingEdit: false,
        link: '',
        linkPreview: {},
        selectedTab: null,
        topicDescription: '',
        postDescription: '',
      }
    },
    computed: {
      ...mapState('users', ['user']),
      ...mapState('auth', { activeUser: 'user' }),
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    methods: {
      toggleTab(type) {
        this.selectedTab = this.selectedTab === type ? null : type
      },
      removeMedia() {
        this.linkPreview.video_url = ''
        this.linkPreview.image = ''
        this.linkPreview.image_url = ''
      },
      removePreview() {
        this.linkPreview = {}
      },
      async getPreview(link) {
        changeBool(this, 'isPendingPreview')
        await api.items.getLinkPreview(link).then(({ data }) => {
          changeBool(this, 'isPendingPreview')
          this.linkPreview = data.data
        }).catch(_ => {
          changeBool(this, 'isPendingPreview')
        })
      },
      updateLink(value) {
        this.link = value
      },
      filesChanged(files) {
        this.files = clone(files)
      },
      onSubmit() {
        const inviteUserData = [
          {
            id: this.user.id,
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            profile_url: `who_is_who/${this.user.id}`,
            username: null,
            combined_name: this.displayUserName(this.user),
          },
        ]
        const groupData = {
          name: null,
          img_id: null,
          description: null,
          users: inviteUserData,
          type: 'cooperations',
        }

        api.items.createItem('groups', groupData).then(({ data })=> {
          if (data.status && data.id) {
            const groupId = data.id
            const topicData = {
              name: this.topicDescription,
              description: null,
              group_id: groupId,
            }
            api.items.createItem('topics', topicData).then(({ data })=> {
              if (data.status && data.id) {
                const topicId = data.id
                const postData = {
                  description: this.postDescription,
                  options: { types: { key: groupId, value: '' },
                    topics: { key: topicId, 'value': '' } },
                  preview: this.linkPreview,
                  files: this.files,
                  author: null,
                }
                api.items.createItem('posts', postData).then(({ data })=> {
                  if (data.status) {
                    this.$router.replace({ name: 'cooperations', query: { cooperationRequest: true } })
                  }
                })
              }
            })
          }
        })
      },
    },
  }
</script>
